import axios from "axios";
import { API } from "@/lib/api";

const keyForSlug = (slug) => `client_portal_token:${slug}`;

export const getClientPortalToken = (slug) => localStorage.getItem(keyForSlug(slug || "")) || "";
export const setClientPortalToken = (slug, token) => localStorage.setItem(keyForSlug(slug || ""), token || "");
export const clearClientPortalToken = (slug) => localStorage.removeItem(keyForSlug(slug || ""));

export function createClientPortalApi(slug) {
  const api = axios.create({ baseURL: API });
  api.interceptors.request.use((config) => {
    const token = getClientPortalToken(slug);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  return api;
}